var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSticker(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.7091 28.1874H7.29809C6.60353 28.1874 6.01562 27.9468 5.53438 27.4656C5.05313 26.9843 4.8125 26.3964 4.8125 25.7018V7.29809C4.8125 6.60353 5.05313 6.01563 5.53438 5.53438C6.01562 5.05313 6.60353 4.8125 7.29809 4.8125H25.7018C26.3964 4.8125 26.9843 5.05313 27.4656 5.53438C27.9468 6.01563 28.1874 6.60353 28.1874 7.29809V21.7091L21.7091 28.1874ZM20.625 26.125V23.375C20.625 22.6187 20.8942 21.9713 21.4328 21.4328C21.9713 20.8942 22.6187 20.625 23.375 20.625H26.125V7.29809C26.125 7.19231 26.0809 7.09533 25.9928 7.00717C25.9046 6.91904 25.8076 6.87497 25.7018 6.87497H7.29809C7.1923 6.87497 7.09533 6.91904 7.00717 7.00717C6.91903 7.09533 6.87497 7.19231 6.87497 7.29809V25.7018C6.87497 25.8076 6.91903 25.9046 7.00717 25.9928C7.09533 26.0809 7.1923 26.125 7.29809 26.125H20.625Z",
    fill: "#505558"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSticker);
export default __webpack_public_path__ + "static/media/Sticker.62d7897daddae961447818ee9e3d3a99.svg";
export { ForwardRef as ReactComponent };